export default __webpack_public_path__ + "static/media/2019.37d7dc54.png";